import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { Grow, Snackbar } from "@mui/material";
import { OcSnackbarAlert } from "oc/components";
import { ocNotificationState } from "states";

export const OcSnackbar = () => {
  const { t } = useTranslation();

  const [openMessage, setOpenMessage] = useRecoilState(ocNotificationState);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenMessage({
      type: openMessage?.type,
      message: "",
    });
  };

  useEffect(() => {
    // Close snackbar on any click or keydown
    const handleClick = () => {
      if (openMessage?.message) {
        handleClose({} as Event);
      }
    };

    const handleKeyDown = () => {
      if (openMessage?.message) {
        handleClose({} as Event);
      }
    };

    document.addEventListener("click", handleClick);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openMessage?.message]);

  return (
    <Snackbar
      open={openMessage?.message ? true : false}
      autoHideDuration={openMessage?.type === "error" ? 16000 : 6000}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      TransitionComponent={Grow}
      style={{
        zIndex: 10001,
      }}
    >
      <OcSnackbarAlert severity={openMessage?.type}>
        {t(openMessage?.message)}
      </OcSnackbarAlert>
    </Snackbar>
  );
};

export default OcSnackbar;
